import { CircleHelp, icons } from '@lucide/vue';
import UserGroupIcon from './UserGroupIcon.vue';

const canonicalNames = new Map(Object.keys(icons).map(name => [name.toLowerCase(), name]));
const legacyNames: Record<string, keyof typeof icons> = {
    trash2: 'Trash',
    history: 'ClockArrowLeft',
    shieldalt: 'Shield',
    smile: 'FaceSlightlySmiling',
    filealt: 'FileText',
    filewarning: 'FileExclamationPoint',
    griplines: 'GripHorizontal',
    tablecolumns: 'Columns2',
    objectgroup: 'Group',
    paste: 'ClipboardPaste',
    shieldquestion: 'ShieldQuestionMark',
    quoteleft: 'TextQuote',
    listul: 'List',
    listol: 'ListOrdered',
    tablecells: 'Table2',
    tablecellslarge: 'Grid2x2',
    sliders: 'SlidersHorizontal',
    linkslash: 'Unlink',
    arrowuprightfromsquare: 'ExternalLink',
    building2: 'BuildingComplex',
    circlehelp: 'CircleQuestionMark',
    filesignature: 'FilePenLine',
    bullhorn: 'Megaphone',
    layout: 'LayoutGrid',
    alignjustify: 'TextAlignJustify',
    message: 'MessageSquare',
    font: 'CaseSensitive',
    code2: 'CodeXml'
};

export function resolveIcon(value?: string | null)
{
    const [name = ''] = value?.trim().split(/\s+/) || [];
    const normalized = name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    if (normalized === 'usergroup')
        return UserGroupIcon;

    const canonical = canonicalNames.get(normalized) || legacyNames[normalized];

    return canonical ? icons[canonical as keyof typeof icons] : CircleHelp;
}
